import React, { useState } from 'react';
import { createClient, updateClient } from '../services/clientService';

const NATIONALITIES = [
  { value: 'V', label: 'V — Venezolano' },
  { value: 'E', label: 'E — Extranjero' },
  { value: 'J', label: 'J — Jurídico' },
  { value: 'G', label: 'G — Gubernamental' },
];
const DOCUMENT_REGEX = /^\d{5,10}(-\d)?$/;

// client: cliente a editar. initial: datos para precargar al crear (ej: la cédula ya escrita)
export default function ClientForm({ client, initial, onCancel, onSaved }) {
  const isEdit = !!client;
  const source = client || initial || {};

  const [nationality, setNationality] = useState(source.nationality || 'V');
  const [document, setDocument] = useState(source.document || '');
  const [name, setName] = useState(source.name || '');
  const [phone, setPhone] = useState(source.phone || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (!DOCUMENT_REGEX.test(document)) {
      setError('Ingrese una cédula o RIF válido (ej: 12345678 o 12345678-9).');
      return;
    }
    if (!name.trim()) {
      setError('El nombre o razón social es obligatorio.');
      return;
    }

    const payload = { nationality, document, name: name.trim(), phone: phone.trim() || null };

    setSaving(true);
    try {
      const data = isEdit ? await updateClient(client.id, payload) : await createClient(payload);
      onSaved(data.client);
    } catch (err) {
      setError(err.response?.data?.msg || 'No se pudo guardar el cliente.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', inset: 0, zIndex: 310,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="section-card"
        style={{ width: '100%', maxWidth: 480, marginBottom: 0, maxHeight: '90vh', overflowY: 'auto' }}
      >
        <div className="section-header">
          <h6>
            <i className="bi bi-person-vcard" style={{ color: 'var(--orig-green)' }} />
            {isEdit ? 'Editar Cliente' : 'Nuevo Cliente'}
          </h6>
          <button
            type="button"
            onClick={onCancel}
            style={{ background: 'none', border: 'none', color: 'var(--orig-text-muted)', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}
            title="Cerrar"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="section-body">
            {error && (
              <div className="alert-orig alert-error" style={{ marginBottom: 16 }}>
                <i className="bi bi-exclamation-triangle-fill" />
                {error}
              </div>
            )}

            <div className="row g-3">
              <div className="col-12 col-sm-5">
                <label className="form-label">Nacionalidad</label>
                <select className="form-select" value={nationality} onChange={e => setNationality(e.target.value)}>
                  {NATIONALITIES.map(n => <option key={n.value} value={n.value}>{n.label}</option>)}
                </select>
              </div>
              <div className="col-12 col-sm-7">
                <label className="form-label">Cédula o RIF</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ej: 12345678-9"
                  value={document}
                  onChange={e => setDocument(e.target.value.replace(/[^\d-]/g, ''))}
                  required
                  autoFocus={!source.document}
                />
              </div>
              <div className="col-12">
                <label className="form-label">Nombre o razón social</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ej: Juan Pérez / Inversiones XYZ C.A."
                  value={name}
                  onChange={e => setName(e.target.value)}
                  required
                  autoFocus={!!source.document}
                />
              </div>
              <div className="col-12">
                <label className="form-label">
                  Teléfono <span style={{ opacity: 0.5, fontSize: '0.8em' }}>(opcional)</span>
                </label>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Ej: 0414-1234567"
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div style={{
            display: 'flex', justifyContent: 'flex-end', gap: 10,
            padding: '14px 20px', borderTop: '1px solid var(--orig-border)',
          }}>
            <button type="button" className="btn-orig btn-orig-outline" onClick={onCancel}>
              Cancelar
            </button>
            <button type="submit" className="btn-orig btn-orig-green" disabled={saving}>
              <i className="bi bi-check2" />
              {saving ? 'Guardando...' : isEdit ? 'Guardar Cambios' : 'Registrar Cliente'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
